import { useCallback, useState } from "react";
import { useCompetitorScopeGuard } from "./useCompetitorScopeGuard";

/**
 * Shared competitor-scope flow: guard → ModalCompetitors → ModalCreateWithIA.
 * Used by the sidebar menu and the Dashboard home features.
 */
export const useOpenCompetitorScopeFlow = ({
  brandInformation,
  onBeforeOpen,
} = {}) => {
  const [isCompetitorsModalOpen, setIsCompetitorsModalOpen] = useState(false);
  const [isCreateWithIAOpen, setIsCreateWithIAOpen] = useState(false);
  const [createWithIAInitialValues, setCreateWithIAInitialValues] = useState(
    {}
  );
  const [createWithIAKey, setCreateWithIAKey] = useState(0);

  const { onTryOpenCompetitorScope } = useCompetitorScopeGuard({
    brandInformation,
  });

  const openCompetitorScope = useCallback(() => {
    onBeforeOpen?.();
    onTryOpenCompetitorScope({
      onOpen: () => setIsCompetitorsModalOpen(true),
    });
  }, [onBeforeOpen, onTryOpenCompetitorScope]);

  const onCloseCompetitorsModal = useCallback(() => {
    setIsCompetitorsModalOpen(false);
  }, []);

  const onCloseCreateWithIA = useCallback(() => {
    setIsCreateWithIAOpen(false);
  }, []);

  const onCompetitorAdsSelected = useCallback((items) => {
    const selectedUrl = items?.[0]?.url;
    if (!selectedUrl) return;

    setCreateWithIAInitialValues({
      referenceAdUrl: selectedUrl,
      mediaType: "image",
      expandAdvancedConfigurationAccordion: true,
    });
    setCreateWithIAKey((prev) => prev + 1);
    setIsCreateWithIAOpen(true);
  }, []);

  return {
    openCompetitorScope,
    modalsProps: {
      isCompetitorsModalOpen,
      onCloseCompetitorsModal,
      onCompetitorAdsSelected,
      isCreateWithIAOpen,
      onCloseCreateWithIA,
      createWithIAKey,
      createWithIAInitialValues,
    },
  };
};
